export default __webpack_public_path__ + "static/media/sounds/selecciona_pulgar.mp3";